import { defineStore } from 'pinia';
import { getLocationFromSessionApi } from '@Api/company.api';
import type { Location } from '@Shared';

export const useLocationStore = defineStore('location', {
    state: () => ({
        location: null as Location | null,
        hasLoaded: false,
    }),

    getters: {
        isLoaded: (state) => state.hasLoaded,
    },
    
    actions: {
        setLocation(newLocation: Location) {
            this.location = newLocation;
            this.hasLoaded = true;
        },

        async loadLocation() {
            this.location = await getLocationFromSessionApi();
            this.hasLoaded = true;
        }
    }
});
